// extracted by mini-css-extract-plugin
export default {"switch":"LanguageSwitch_switch__JntML","current":"LanguageSwitch_current__EL-cw","dropdown":"LanguageSwitch_dropdown__Ue6yi","flag":"LanguageSwitch_flag__nPzzm"};